import config from 'config';

import styles from './Layout.module.scss';

export type LayoutBackgroundProps = {};

const LayoutBackground = (props: LayoutBackgroundProps): JSX.Element => (
  <picture className={styles.background}>
    <source srcSet={`${config.app.publicUrl}/assets/images/bg.webp`} type="image/webp" />
    <source srcSet={`${config.app.publicUrl}/assets/images/bg.png`} type="image/png" />
    <img src={`${config.app.publicUrl}/assets/images/bg.png`} alt="background" />
  </picture>
);

export default LayoutBackground;
